import { useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Masthead() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full">
      <div className="bg-primary-600 text-background-50">
        <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-2 text-[11px] tracking-wide md:px-6 md:text-xs">
          <i className="ri-refresh-line text-sm" />
          <span>入口已更新 · 2026 年 9 月 11 日 · 当前 4 条线路全部在线</span>
        </div>
      </div>

      <div className="border-b border-background-200/70 bg-background-50/90 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
          <a href="#top" className="flex cursor-pointer items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
              <i className="ri-fire-line text-lg" />
            </span>
            <h1 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
              黑料官网
            </h1>
            <span className="hidden rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900 sm:inline-block">
              入口导航
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:block">
            <a
              href="#entry"
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-arrow-right-up-line text-base" />
              立即进入
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
            <nav className="flex flex-col">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="cursor-pointer whitespace-nowrap border-b border-background-100 py-3 text-sm text-foreground-800"
                >
                  {link.label}
                </a>
              ))}
            </nav>
            <a
              href="#entry"
              onClick={() => setOpen(false)}
              className="mt-4 block cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              立即进入官网
            </a>
          </div>
        )}
      </div>
    </header>
  );
}